module.exports = __webpack_public_path__ + "img/187.bdfb7f4a.jpg";